export const PRODUCT_ADMIN_ACTION = {
    GET_PRODUCT_LIST: "PRODUCT_ADMIN_ACTION/GET_PRODUCT_LIST",
    CREATE_PRODUCT: "PRODUCT_ADMIN_ACTION/CREATE_PRODUCT",
    GET_PRODUCT_DETAIL: "PRODUCT_ADMIN_ACTION/GET_PRODUCT_DETAIL",
    UPDATE_PRODUCT_DETAIL: "PRODUCT_ADMIN_ACTION/UPDATE_PRODUCT_DETAIL",
    DELETE_PRODUCT_DETAIL: "PRODUCT_ADMIN_ACTION/DELETE_PRODUCT_DETAIL"
};
